// Het doel van de coin-voortgangsbalk, zoals in de bovenbalk van ui-v1
// (CoinAccountProgressBar): de balk vult zich naar 1000 coins en blijft daarboven
// vol. Gedeeld door de balk in de sidebar en de tegel op "Mijn coins".
export const COIN_GOAL = 1000;

export const coinGoalPercentage = (rate) => (
  Math.min(100, Math.max(0, ((Number(rate) || 0) / COIN_GOAL) * 100))
);
